import React from 'react'
import AutoWorksPlayer from 'autoworks-player'
import {
  transformExteriorImages,
  transformThumbnail,
  transformPanorama,
  transformPanoramaPoster,
  transformPhoto
} from './lib/transform-images'
import useScrollBlock from './lib/useScrollBlock'

import 'autoworks-player/dist/AutoWorksPlayer.css'

const VehiclePlayer = ({
  children,
  exteriorImages,
  panorama,
  images,
  model
}) => {
  const [blockScroll, allowScroll] = useScrollBlock()
  const items = []

  const options = {
    hideBranding: true,
    ratio: 10 / 16,
    thumbnailRatio: 1 / 2,
    modalZIndex: 10000,
    showcaseHeading: model,
    colors: {
      accent: '#1E4F67',
      accentText: '#fff'
    }
  }

  if (exteriorImages.length > 0) {
    items.push({
      type: 'exterior',
      // id: '',
      thumbnail: transformThumbnail({
        image: exteriorImages[0],
        ratio: options.thumbnailRatio
      }),
      images: transformExteriorImages({
        images: exteriorImages,
        ratio: options.ratio
      }),
      reverseDirection: true
    })
  }

  if (panorama) {
    items.push({
      type: 'interior',
      // id: '',
      thumbnail: transformThumbnail({
        image: panorama,
        ratio: options.thumbnailRatio
      }),
      src: transformPanorama({ image: panorama }),
      poster: transformPanoramaPoster({
        image: panorama,
        ratio: options.ratio
      }),
      hotspots: []
    })
  }

  if (images.length > 0) {
    images.forEach((image) => {
      const formattedImages = transformPhoto({ image, ratio: options.ratio })
      items.push({
        type: 'photo',
        // id: '',
        thumbnail: transformThumbnail({
          image,
          ratio: options.thumbnailRatio
        }),
        ...formattedImages
      })
    })
  }

  return (
    <AutoWorksPlayer
      {...options}
      items={items}
      infoChildren={children}
      onShowcaseEnter={blockScroll}
      onShowcaseExit={allowScroll}
    />
  )
}

export default VehiclePlayer
